import { useEffect, useRef } from 'react';
import WebUniversal, { WUExtendPropsType } from '../../system/WebUniversalNewEx';
import EditComponent from './MembershipApplicablesShopsEdit';
import { columnsheadId } from '../../universal/columnshead';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';

const WebComponent = (props: any) => {
    const title = '会员适合店铺';
    const ref = useRef<any>(undefined);
    const { closeModal, data } = props;

    useEffect(() => {

    }, []);

    //表头
    const columnsHead = [
        {
            title: '店铺',
            dataIndex: 'shop',
            render: (text: any) => text?.shopName
        },
        {
            title: '会员类型',
            dataIndex: 'membershipType',
            render: (text: any) => text?.typeName
        },
        {
            title: '默认支付',
            dataIndex: 'isDefaultPayment',
            render: (val: any) => val === true ? '是' : '否'
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: title,
        apiId: 'membershipApplicablesShops',
        columns,
        EditComponent,
        serviceId: 'business',
        sendPageData: data,
        showStates: true
    };

    return (
        <>
            <AntDraggableModal
                title={title}
                open={true}
                okText='确定'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={closeModal}
                closable={false}
                maskClosable={false}
                width={800} >
                <WebUniversal props={extendProps} ref={ref} />
            </AntDraggableModal>
        </>
    )
}

export default WebComponent;
